// @deprecated Use src/components/ProgressStepper/PROGRESS_STEPPER_APPEARANCES.js
export var PROGRESS_STEPPER_APPEARANCES = {
  complete: 'complete',
  incomplete: 'incomplete',
  warning: 'warning',
  error: 'error',
  none: 'none'
};